console.log("I'm from Product Cross Js File");
if (!customElements.get("product-cross-links")) {
  customElements.define(
    "product-cross-links",
    class ProductCrossLinks extends HTMLElement {
      constructor() {
        super();
        this.crossSellLinks = this.querySelectorAll("li[data-month]"); // Grab cross-sell links
      }

      variantIdChangedUnsubscriber = undefined;

      connectedCallback() {

        document.addEventListener("variantChange", (event) => {
          console.log("Variant changed:", event.detail.variant);
          this.updateCrossSellLinks(event.detail.variant);
        });

        // Initial update for the default variant
        const currentVariant = {
          option1: this.dataset.variantOption1 || "",
          option2: this.dataset.variantOption2 || "",
        }; // Specifying only option1 and option2, since only these 2 props will be used in updateCrossSellLinks
        this.updateCrossSellLinks(currentVariant);
      }

      disconnectedCallback() {
        if (this.variantIdChangedUnsubscriber) {
          this.variantIdChangedUnsubscriber(); // Unsubscribe from the event
        }
      }

      async updateCrossSellLinks(currentVariant) {
        const url = new URL(window.location.href);
        const firstPathSegment = url.pathname.split("/")[1];
        const localePrefix =
          firstPathSegment === "products" ? "" : `/${firstPathSegment}`;

        this.crossSellLinks.forEach(async (link) => {
          const productHandle = link.dataset.productHandle; // Use `data-product-handle`

          if (productHandle) {
            try {
              const product = await fetch(
                `${localePrefix}/products/${productHandle}.js`
              ).then((res) => res.json());

              // First try to match both options if they exist
              let matchingVariant = product.variants.find(
                (v) =>
                  v.option1 === currentVariant.option1 &&
                  (currentVariant.option2
                    ? v.option2 === currentVariant.option2
                    : true)
              );

              // If no match found, try matching just option1 only
              if (!matchingVariant) {
                matchingVariant = product.variants.find(
                  (v) => v.option1 === currentVariant.option1
                );
              }

              const anchor = link.querySelector("a");
              const productUrl = product.url.startsWith(localePrefix)
                ? product.url
                : `${localePrefix}${product.url}`; // Ensure no duplicate prefixes

              if (matchingVariant) {
                anchor.href = `${productUrl}?variant=${matchingVariant.id}`;
                link.addEventListener("click", (event) => {
                  console.log("clicked");
                  event.preventDefault();
                  window.location.href = anchor.href;
                });
              } else {
                anchor.href = productUrl;
              }
            } catch (error) {
              console.error(
                `Failed to fetch product for handle: ${productHandle}`,
                error
              );
            }
          }
        });
      }
    }
  );
}
